import { Component, computed, DestroyRef, inject, OnInit, viewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core";
import { DefaultFormComponent } from "../../shared/default-form/default-form.component";
import { CreateUpdateNoticeDTO } from "../model/CreateUpdateNoticeDTO";
import { Temporality } from "../model/temporality";
import { UpdateNoticeService } from "../service/updatenotice.service";
import { AisProduct } from "src/app/shared/enums/AisProducts";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "DD MMM YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-ais-product-form",
  standalone: false,
  templateUrl: "./ais-product-form.component.html",
  styleUrl: "./ais-product-form.component.scss",
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AisProductFormComponent implements OnInit {
  private _route = inject(ActivatedRoute);

  private _router = inject(Router);

  private _destroyRef = inject(DestroyRef);

  private _updateNoticeService = inject(UpdateNoticeService);

  private _defaultFormCmp = viewChild(DefaultFormComponent);

  formValid = computed(() => this._defaultFormCmp().formValid());

  ngOnInit(): void {}

  save() {
    if (this._defaultFormCmp()) {
      const attachments = this._defaultFormCmp().uploader.queue.map((item) => item.file);
      const payload: CreateUpdateNoticeDTO = CreateUpdateNoticeDTO.parse(this._defaultFormCmp().form.getRawValue());

      console.log(this._defaultFormCmp().form.getRawValue(), "### FORM VALUES");
      console.log(payload, "### PAYLOAD DTO");
      console.log(attachments, "### attachments");

      this._updateNoticeService
        .addUpdateNotice(payload, attachments)
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe(() => {
          this._router.navigate(["/change-requests"]);
        });
    }
  }

  onAisProductChanged(event: AisProduct) {
    this._router.navigate([event], { relativeTo: this._route.parent });
  }
}
